export default {
  hero_label: 'AI Transformation for Japan',
  hero_headline_1: 'AIXで日本を',
  hero_headline_2: '強くする',
  hero_cta_services: 'Our Services',
  hero_cta_contact: 'Contact Us',
  hero_scroll: 'Scroll',

  service_heading: '事業内容',
  service_heading_en: 'SERVICE',
  service_lead_title: '"AI"と"X"を掛け合わせるトータルコンサルティング',
  service_lead_desc: 'AIとあらゆる領域（X）を掛け合わせ、企業の変革と成長を実現するトータルコンサルティング。\n弊社ではAIX事業として上流から下流まですべてのフェーズに対応し、クライアントの課題を解決し成功に導きます。',
  service_cta: '事業内容を詳しく知る',
  service_card_learn_more: '事業を詳しく知る',
  service_issues_title: 'こんなお困り事はありませんか?',
  service_issues_contact: 'お問い合わせ',
  service_tab_assigned_prefix: '',
  service_tab_assigned_suffix: 'の担当がお伺いいたします。',

  issues: [
    { label: 'AI戦略の立案ができない', service: 'consulting' },
    { label: 'DX推進がうまく進まない', service: 'consulting' },
    { label: '競合他社にAI活用で遅れている', service: 'consulting' },
    { label: '新規AI事業の立ち上げに悩んでいる', service: 'consulting' },
    { label: 'AI導入後の運用・管理が難しい', service: 'manager' },
    { label: 'データ活用・分析ができていない', service: 'manager' },
    { label: '業務自動化を進めたい', service: 'manager' },
    { label: '社員のAIリテラシーが低い', service: 'training' },
    { label: 'AI活用ノウハウが社内にない', service: 'training' },
    { label: 'AI人材の育成に課題がある', service: 'training' },
  ],

  philosophy_1: 'AIを本質的価値に繋げることが「AIX」',
  philosophy_2: 'AIを単なるツールで終わらせず、\n企業の競争力・生産性・事業価値へと転換する。',
  philosophy_3: 'それがAIX（AI Transformation）。\nAIを本質的価値につなげ、企業と産業の変革を実現します。',
  philosophy_cta_1: '私たちの',
  philosophy_cta_2: 'フィロソフィー',

  member_heading: 'メンバー',
  member_heading_en: 'MEMBER',
  member_desc: 'AIで日本を変えるプロフェッショナル集団。',
  member_cta: 'メンバーをもっと見る',


  achievements_heading: '取引実績',
  achievements_heading_en: 'TRACK RECORD',
  achievements_desc: '大手上場企業様からスタートアップ企業様まで、業界を問わずベストフィットな戦略構築と実行支援をさせて頂きます。',
  achievements_note: '※ロゴ掲載許可を頂いた、一部クライアントのみを掲載させて頂いております。',
  achievements_cases_cta: '導入事例を見る',
  achievements_stats_title: '導入で生まれた成果',
  achievements_stats_note: '※クライアント企業の調査・プロジェクトデータに基づく算出（2025年度実績）',
  stats_efficiency_label: '平均業務効率化率',
  stats_efficiency_desc: 'AI導入後の\n業務工数削減平均値',
  stats_cost_label: '平均コスト削減率',
  stats_cost_desc: 'AI活用による\n運用コスト削減平均値',
  stats_retention_label: 'プロジェクト継続率',
  stats_retention_desc: '導入後も継続して\nご支援いただける割合',
};